<div style="padding: 32px;">
  <h3 class="mat-h2" style="margin-left: 16px;">Mis materias</h3>
  <ng-container *ngIf="materias; else loading">
    <div *ngFor="let col of columnas; index as indexCol" [style.width]="anchoColumnas"
         style="display: inline-block; vertical-align: top;padding: 12px;"
          #contenedorMaterias>
      <mat-card *ngFor="let materia of col.els" style="margin-bottom: 12px;
         width: 100%;
         padding: 12px;">
        <mat-card-title>{{materia.nombreCompleto}}</mat-card-title>
        <div class="flex-wrap" style="justify-content: space-between; align-items: center;">
          <label class="inline-flex" style="flex-grow: 4;"><strong>Ausencias y retardos</strong></label>
          <span class="spacer"></span>
          <div class="inline-flex" style="position: relative;">
            <!--[disabled]="materia.ausencias == 0"-->
            <button mat-icon-button (click)="detallesAsistencia(materia, 'detalleAus')" class="inline-flex"
                    style="text-align: center;">{{materia.ausencias}}</button>
            <div *ngIf="materia.detalleAus && materia.detalleAus.show"
                 class="detail-container mat-elevation-z24"
                 [ngClass]="{'right0': indexCol + 1 === columnas.length }">
              <div class="inline-flex">
                <div class="flex-wrap" style="justify-content:space-between;">
                  <label class="inline-flex"><strong>Ausencias</strong></label>
                  <label class="inline-flex"><strong>Retardos</strong></label>
                  <label class="inline-flex"><strong>Total</strong></label>
                </div>
                <ng-container *ngFor="let appendable of ['', '0', '1', '2', '3']">
                  <div class="flex-wrap">
                    <ng-container
                      *ngFor="let tipoAusencia of ['A' + appendable, 'R' + appendable, 'AR' + appendable]; index as i">
                      <!--<small><pre>{{tipoAusencia | json}}</pre></small>-->
                      <div class="inline-flex">
                        <ng-container *ngIf="i < 2">
                          {{tipoAusencia}}:
                        </ng-container>
                        {{i == 1 ? (materia.detalleAus.listaDetalles | asistenciaCodigo:
                        tipoAusencia).retardos : (materia.detalleAus.listaDetalles | asistenciaCodigo:
                        tipoAusencia).numerico}}
                        <ng-container *ngIf="i == 2">
                          <small style="color: gray;">({{(materia.detalleAus.listaDetalles | asistenciaCodigo:
                            tipoAusencia).porcentaje}}%)
                          </small>
                        </ng-container>
                        <ul class="detail-list"
                            *ngIf="i < 2 && (materia.detalleAus.listaDetalles | asistenciaCodigo: tipoAusencia).fechas.length > 0">
                          <li
                            *ngFor="let fecha of (materia.detalleAus.listaDetalles | asistenciaCodigo: tipoAusencia).fechas"
                            style="color: gray">
                            <small>{{fecha}}</small>
                          </li>
                        </ul>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="materia-card-content">
          <div class="flex-wrap" style="justify-content: center; align-items: center;">
            <label class="inline-flex" style="flex-grow: 4;">
              <strong>Nivelaciones</strong>
            </label>
            <span class="spacer"></span>
            <!--            <small><a [routerLink]="['/', 'estudio', 'familia', 'alumno', me.id, 'nivelaciones']">Ver más</a></small>-->
            <div class="inline-flex" style="position: relative;">
              <!--[disabled]="materia.ausencias == 0"-->
              <button mat-icon-button class="inline-flex"
                      (click)="detallesAsistencia(materia, 'detalleNiv')"
                      style="text-align: center;">{{materia.nivelaciones.length}}</button>
              <div *ngIf="materia.detalleNiv && materia.detalleNiv.show"
                   class="detail-container mat-elevation-z24"
                   [ngClass]="{'right0': indexCol + 1 === columnas.length }">
                <ul *ngIf="materia.nivelaciones && materia.nivelaciones.length > 0; else noNivelaciones"
                    style="opacity: .6; width: 100%;">
                  <li *ngFor="let nivelacion of materia.nivelaciones" style="margin-bottom: 8px;">
                    <div class="flex-wrap full-width" style="align-items: center;">
                      <mat-icon class="md-14" style="margin-right: 4px;">calendar_today</mat-icon>
                      <span class="inline-flex" style="flex-grow: 2">{{nivelacion.fechaCorta}}</span>
                      <span class="spacer"></span>
                      <mat-icon class="md-14" style="margin-right: 4px;">alarm</mat-icon>
                      <span class="inline-flex">{{nivelacion.horaCita}}</span>
                    </div>
                    <small>Lugar: {{nivelacion.lugar}}</small>
                  </li>
                </ul>
                <ng-template #noNivelaciones>
                  <p style="opacity: .6">
                    Sin nivelaciones programadas
                  </p>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
        <div>
          <label><strong>Unidades, evidencias y retroalimentación</strong></label>
          <ul *ngIf="materia.unidades && materia.unidades.length > 0; else noUnidades">
            <li *ngFor="let unidad of materia.unidades">
              <a [routerLink]="['/', 'estudio', 'familia', 'alumno', me.id, 'unidad', unidad.id]">
                <small>{{unidad.nombre}}</small>
              </a>
              <ul *ngIf="unidad.eventos && unidad.eventos.length > 0; else noEventos" style="padding-left: 6px">
                <li *ngFor="let evento of unidad.eventos" class="flex-wrap" style="align-items: center;">
                  <a [routerLink]="['/', 'estudio', 'familia', 'alumno', me.id, 'unidad', unidad.id,
                  {outlets: {retroalimentacion: ['retroalimentacion', evento.id]}}]">
                    <small class="inline-flex" style="flex-grow: 3;">{{evento.evento.nombre}}</small>
                  </a>
                  <span class="spacer"></span>
                  <mat-icon class="md-14">chat_bubble</mat-icon>
                  <sup>{{evento.comentariosNuevos}}</sup>
                </li>
              </ul>
              <ng-template #noEventos>
                <p style="opacity: .6">
                  <small>Sin eventos registrados</small>
                </p>
              </ng-template>
            </li>
          </ul>
          <ng-template #noUnidades>
            <p style="opacity: .6">
              <small>Sin unidades publicadas</small>
            </p>
          </ng-template>
        </div>
        <mat-card-actions>
          <div class="flex-wrap">
            <span class="spacer"></span>
            <button mat-button
                    [routerLink]="['/', 'estudio', 'retroalimentacion', 'dashboard', 'materia', materia.id, 'alumno', me.id]">
              Consultar
            </button>
          </div>
        </mat-card-actions>
      </mat-card>
    </div>
    <div *ngIf="overlay"
      class="custom-overlay"
         [style.height]="overlayHeight"
         style="position: absolute; top: 0; left: 0;width: 100%;"></div>
  </ng-container>
  <ng-template #loading>
    <mat-spinner mode="indeterminate"></mat-spinner>
  </ng-template>
</div>
